// Chakra imports
import { Box, Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';

// Assets
import { MdEdit } from 'react-icons/md';
import { MastercardIcon, VisaIcon } from 'components/icons/Icons';

interface PaymentMethodData {
  id: string;
  type: string;
  card?: {
    brand: string;
    last4: string;
    exp_month: number;
    exp_year: number;
  };
}

interface PaymentMethodProps {
  paymentMethod?: PaymentMethodData;
  onEditClick?: () => void;
  [x: string]: any;
}

export default function PaymentMethod({
  paymentMethod,
  onEditClick,
  ...rest
}: PaymentMethodProps) {
  // Chakra Color Mode
  const textColorSecondary = useColorModeValue('secondaryGray.500', 'white');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const iconColor = useColorModeValue('#4318FF', 'white');
  const borderColor = useColorModeValue('secondaryGray.400', 'whiteAlpha.100');

  const getCardIcon = (brand: string) => {
    switch (brand.toLowerCase()) {
      case 'visa':
        return (
          <VisaIcon color={iconColor} w="24px" h="24px" mt="3px" me="10px" />
        );
      case 'mastercard':
        return <MastercardIcon w="24px" h="24px" mt="3px" me="10px" />;
      default:
        return <MastercardIcon w="24px" h="24px" mt="3px" me="10px" />;
    }
  };

  const formatExpiryDate = (month: number, year: number) => {
    return `${month.toString().padStart(2, '0')}/${year.toString().slice(-2)}`;
  };

  return (
    <Box flexDirection="column" w="100%" {...rest} h="stretch" pt={12}>
      <Text
        color={textColor}
        fontSize="lg"
        fontWeight="700"
        lineHeight="100%"
        mb={4}
      >
        Payment Method
      </Text>
      <Flex direction="column">
        {paymentMethod && paymentMethod.card ? (
          <Flex
            align="center"
            border="1px solid"
            borderColor={borderColor}
            borderRadius="16px"
            p="22px 26px"
            mb="20px"
          >
            {getCardIcon(paymentMethod.card.brand)}
            <Text
              me="auto"
              fontSize="md"
              fontWeight="500"
              color={textColorSecondary}
            >
              •••• •••• •••• {paymentMethod.card.last4}
            </Text>
            <Text fontSize="sm" color={textColorSecondary} me="10px">
              Expires{' '}
              {formatExpiryDate(
                paymentMethod.card.exp_month,
                paymentMethod.card.exp_year,
              )}
            </Text>
            <Flex
              cursor="pointer"
              h="max-content"
              w="max-content"
              onClick={onEditClick}
            >
              <Icon color={textColorSecondary} as={MdEdit} w="20px" h="20px" />
            </Flex>
          </Flex>
        ) : (
          <Flex
            align="center"
            border="1px solid"
            borderColor={borderColor}
            borderRadius="16px"
            p="22px 26px"
            mb="20px"
          >
            <Text
              me="auto"
              fontSize="md"
              fontWeight="500"
              color={textColorSecondary}
            >
              No payment method on file
            </Text>
            <Flex
              cursor="pointer"
              h="max-content"
              w="max-content"
              onClick={onEditClick}
            >
              <Icon color={textColorSecondary} as={MdEdit} w="20px" h="20px" />
            </Flex>
          </Flex>
        )}
      </Flex>
    </Box>
  );
}
